import React from 'react';
import ReactDOM from 'react-dom';

export class BezirkLine extends React.Component {
	render() {

		if (!this.props.data.show) {
			return null
		}
		
		let x2, y2;
		if (window.innerWidth < this.props.breakingPoint) {
			let map_pos = this.props.leafletMapRef.current.leafletElement._container.offsetHeight
			x2 = "50%";
			y2 = map_pos;
		} else {
			let overview_pos = this.props.overviewRef.current.getBoundingClientRect()
			if ("x" in overview_pos) {
				x2 = overview_pos.x;
			} else {
				x2 = overview_pos.right - overview_pos.width; // Edge
			}
			y2 = 243;
		}
		
		// Wenn sich die Maße der Karte durch ein Resize verändert, bekommmen Karten-Layers einen
		// translate3d-Style. Damit die Linie als Child des transformten Divs weiterhin auf die richtige Stelle zeigt,
		// muss der translate3d-Style umgekehrt werden.
		let transform = this.props.leafletMapRef.current.contextValue.map._mapPane.style.transform
		let style = {}
		if (transform) {
			transform = transform.replace('translate3d(', '').replace('px', '').split(',')
			style.transform = "translate3d(" 
								+ ((-1) * parseInt(transform[0])).toString() + 'px, ' 
								+ ((-1) * parseInt(transform[1])).toString() + 'px, 0px)'
		}
		return ReactDOM.createPortal(
			(
				<svg className="bezirkLine" style={style}>
					<line
						x1={this.props.data.x1} 
						y1={this.props.data.y1} 
						x2={x2} 
						y2={y2} 
						stroke="black"
						strokeWidth="0.5"
					/>
					<circle 
						r="4"
						cx={this.props.data.x1} 
						cy={this.props.data.y1} 
					/>
				</svg>
			), this.props.leafletMapRef.current.contextValue.map._mapPane
		)
	}
}